import {useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {communityService} from "../../../services/communityService/communityService";
import Loader from "../../../components/common/Loader";
import DiscussionsCommentList from "../../../components/DiscussionsCommentList";
import useRenderTextEditorContent from "../../../hooks/useTextEditorContent";
import TextEditorContent from "../../../components/TextEditorContent";
import {AiFillHeart, AiOutlineHeart} from "react-icons/ai";
import {CommentsService} from "../../../services/commentsService/commentsService";
import {toast} from "react-toastify";
import CustomBreadcrumbs from "../../../components/CustomBreadcrumbs/CustomBreadcrumbs";

const MasterClassDiscussionDetails = () => {
    const [masterClassDiscussionDetails, setMasterClassDiscussionDetails] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const { id } = useParams();
    const renderAnswer = useRenderTextEditorContent();

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        getMasterClassDiscussionDetails();
    }, []);

    const getMasterClassDiscussionDetails = async () => {
        setIsLoading(true);
        try {
            const response = await communityService.getMasterClassDiscussionDetails(id);
            setMasterClassDiscussionDetails(response.data);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleLike = async () => {
        try {
            const response = await communityService.likeMasterClass(id);
            setMasterClassDiscussionDetails(response.data);
            toast.success('Done!');
        } catch (err) {
            toast.error('Like discussion failed. Please try again.');
        }
    };

    return (
        <>
            <div className="container-fluid">
                {isLoading ? (
                    <Loader />
                ) : (
                    <>
                        <CustomBreadcrumbs
                            currentPageTitle='Community'
                            pages={[
                                {
                                    title: 'Speaker Discussions',
                                    to: `/master-class/discussions`
                                },
                                {
                                    title: masterClassDiscussionDetails?.title,
                                    to: `/master-classes/${masterClassDiscussionDetails?.id}`
                                },
                            ]}
                        />
                        <div className="container m-4">
                            <div className="row">
                                <div className="col-lg-6 col-md-12">
                                    <h1>{masterClassDiscussionDetails?.title}</h1>
                                    <TextEditorContent
                                        text={masterClassDiscussionDetails?.description}
                                    />
                                    <div className="d-flex justify-content-end align-items-center" onClick={handleLike}>
                                        {masterClassDiscussionDetails?.is_liked ? (
                                            <AiFillHeart
                                                fill="red"
                                                fontSize={30}
                                                style={{cursor: "pointer"}}
                                            />
                                        ) : (
                                            <AiOutlineHeart
                                                fontSize={30}
                                                style={{cursor: "pointer"}}
                                            />
                                        )}
                                        <span className="fs-5 fw-bold discussion-topic__likes-count">
                                            {masterClassDiscussionDetails?.likes_count}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="master-class__comments">
                                        <DiscussionsCommentList
                                            path={`master-classes/${id}`}
                                            relatedTitlesToDisplay={['lessons']}
                                            highlightingCompareId={masterClassDiscussionDetails?.user.id}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default MasterClassDiscussionDetails;